"use client";

import styles from "./WhyAmity.module.scss";
import ArrowRight from "@/SvgIcons/ArrowRight";
import { IModalActions, ModalTypes } from "@/types/modal";

import { ModalContext } from "@/context/ModalContext";
import { useContext } from "react";
import { pushToDataLayer } from "@/helpers/gtag";
import { updateStateSession } from "@/context/utils";

interface ClientButtonProps {
  isLambdaApi?: boolean;
  associatedPrograms?: any;
}
const ClientButton = ({isLambdaApi, associatedPrograms }:ClientButtonProps) => {
  const { modalDispatch } = useContext(ModalContext);

  const onClickHandler = () => {

    setTimeout(()=>{
        pushToDataLayer({
            section_name : "fast_track_your_career",
            event_name : "lead_initiate",
            cta_text : "FAST TRACK YOUR CAREER",
            page_type : "Home Page",
            page_url : window.location.href || "NA",
            header_title : "Why Choose Amity Online?"
        })

        updateStateSession(
            {
                parentSection : "fast_track_your_career",
                leadStartingCta: "FAST TRACK YOUR CAREER",
            }
        )
    },400)

    modalDispatch ({
        type: IModalActions.OpenModal,
        data: {
          modalType: ModalTypes.ConnectModal,
          modalData: { associatedPrograms, isLandingPage: true },
        }}
      );

  };

  return (
    <button onClick={onClickHandler} className={`${styles.cusBtn} ${styles.btnYellow}`}>
      Fast-track your career
      <span className={styles.arrowIcon}>
        <ArrowRight color="#1a325d" />
      </span>
    </button>
  );
};

export default ClientButton;
